import React from 'react';
import PropTypes from 'prop-types';
//import '@fortawesome/fontawesome-free/css/all.css';

// https://fontawesome.com/icons?d=gallery&m=free
const Icon = ({ name, stylePrefix = 'fas', className = '' }) => {
    return (
        <i className={`${stylePrefix} fa-${name} ${className}`}></i>
    );
};

Icon.propTypes = {
    name: PropTypes.string.isRequired,
    stylePrefix: PropTypes.string,
    className: PropTypes.string,
};

export default Icon;
